import { VacationRequestForm } from '../../../components/VacationRequestForm';
import { TOUR_DEMO_BALANCE } from './tourDemo.definitions';

export function TourDemoForm() {
    return (
        <VacationRequestForm
            balance={TOUR_DEMO_BALANCE}
            isSubmitting={false}
            onSubmit={() => {}}
            earliestStartDate={undefined}
            scheduleLimitDate={undefined}
            holidays={[]}
            managerSuggestions={[]}
            hasMultipleAllocationManagers={false}
            currentCollaboratorId={undefined}
            initialValues={{ modality: '30' }}
        />
    );
}

export default TourDemoForm;
